import { styled } from "@mui/material/styles";

const BarBox = styled("div")(
    ({ theme }) => ({
        position: "relative",
        width: "100%",
        height: "3rem",
        display: "flex",
        overflowY: "visible",
        marginTop: theme.spacing(3.5),
    })
);

const Bar = styled("div", {
    shouldForwardProp: (prop) => (
        prop !== "color" &&
        prop !== "flexGrow" &&
        prop !== "label"
    )
})(({ theme, color, flexGrow, end, label }) => ({
    backgroundColor: color,
    flexGrow,
    position: "relative",
    height: "2rem",
    fontFamily: "montserrat",
    fontWeight: 700,
    "&::after": {
        fontSize: "1.3rem",
        position: "absolute",
        content: `"${end || ""}"`,
        top: "100%",
        bottom: 0,
        right: "-1.6rem",
        zIndex: theme.zIndex.appBar,
    },
    ...(label && {
        "&::before": {
            fontSize: "2rem",
            position: "absolute",
            content: `"👇"`,
            top: "-2.8rem",
            bottom: "100%",
            left: `calc(${label}% - 1.3rem)`,
        }
    }),
    "&:first-of-type": {
        borderTopLeftRadius: "2rem",
        borderBottomLeftRadius: "2rem",
    },
    "&:last-of-type": {
        borderTopRightRadius: "2rem",
        borderBottomRightRadius: "2rem",
    },
}));

export default function PerfBar(props) {
    const { p1, p2, score } = props;

    return (
        <BarBox>
            <Bar color="#04cb66" flexGrow={2} end={`${p1.toFixed(1)}s`} label={score <= p1 && score / p1 * 100} />
            <Bar color="#fbc02d" flexGrow={5} end={`${p2.toFixed(1)}s`} label={(score > p1 && score <= p2) && (score - p1) / (p2 - p1) * 100} />
            <Bar color="#ff3333" flexGrow={2} label={score > p2 && (100 - p2 / score * 100)} />
        </BarBox>
    );
};